import Icon from '../components/Icon.vue'

Icon.register({
  'user-check': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M224 256c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128-57.3 128-128 128zM313.6 288c74.2 0 134.4 60.2 134.4 134.4v41.6c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-41.6c0-74.2 60.2-134.4 134.4-134.4h16.7c22.3 10.2 46.9 16 72.9 16s50.7-5.8 72.9-16h16.7zM636.6 159.6c4.6 4.6 4.5 12.1-0.1 16.8l-141.3 140.2c-4.7 4.6-12.2 4.6-16.8-0.1l-81.7-82.3c-4.6-4.7-4.6-12.2 0.1-16.8l28.1-27.9c4.7-4.6 12.2-4.6 16.8 0.1l45.5 45.8 104.8-104c4.7-4.6 12.2-4.6 16.8 0.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-check.js
// module id = 2059
// module chunks = 0